import { Settings, BarChart3 } from 'lucide-react'

interface HeaderProps {
  onSettingsClick: () => void
  onStatsClick: () => void
}

/**
 * Top header with logo, UK stats, and settings icons
 */
export function Header({ onSettingsClick, onStatsClick }: HeaderProps) {
  return (
    <header className="fixed top-0 left-0 right-0 bg-gradient-to-r from-brand-700 to-brand-500 z-50 safe-area-pt shadow-md">
      <div className="flex items-center justify-between h-14 px-4 max-w-lg mx-auto">
        {/* Logo */}
        <div className="flex items-center">
          <span className="text-2xl text-white tracking-tight">
            <span className="font-bold">Power</span>
            <span className="font-light">Map.co.uk</span>
          </span>
        </div>

        <div className="flex items-center">
          {/* UK stats button */}
          <button
            onClick={onStatsClick}
            className="flex items-center justify-center w-10 h-10 min-h-[44px] rounded-lg text-white/80 hover:text-white hover:bg-white/10 transition-colors"
            aria-label="Open UK charging stats"
          >
            <BarChart3 size={22} />
          </button>

          {/* Settings button */}
          <button
            onClick={onSettingsClick}
            className="flex items-center justify-center w-10 h-10 min-h-[44px] rounded-lg text-white/80 hover:text-white hover:bg-white/10 transition-colors"
            aria-label="Open settings"
          >
            <Settings size={22} />
          </button>
        </div>
      </div>
    </header>
  )
}
